export enum UNIVERSES_ACRONYMS {
  SMA = 'SMA',
  ETF = 'ETF',
  INDICES = 'Indices',
}

export enum UNIVERSES_EN_CA {
  CASH = 'Cash',
  CLOSED_END_FUNDS = 'Closed End Funds',
  EXCHANGE_TRADED_FUNDS = 'Exchange Traded Funds',
  HEDGE_FUNDS = 'Hedge Funds',
  INDICES = 'Indices',
  INSURANCE_FUNDS = 'Insurance Funds',
  INVESTMENT_TRUST = 'Investment Trust',
  MUTUAL_FUNDS = 'Mutual Funds',
  PENSION_FUNDS = 'Pension Funds',
  PORTFOLIOS = 'Portfolios',
  SAVINGS_ACCOUNTS = 'Savings Accounts',
  SEGREGATED_FUNDS = 'Segregated Funds',
  SEPARATELY_MANAGED_ACCOUNTS = 'Separately managed accounts',
}
